const Mock = require('mockjs');
var result = Mock.mock({
    // 属性 list 的值是一个数组，其中含有 1 到 10 个元素
    'list|10': [{
        // 属性 id 是一个自增数，起始值为 1，每次增 1
        'key|+1': 1,
        'termsname': '@cword(5,8)条款',
        'updatelist': () => {
            let tagArr = [
                'React生命周期的命名一直都是非常语义化的',
                '所以尽量将其写到函数的末尾',
                '如上面代码的例子所示',
                '离开设法健康快乐速度加快立法',
                '看来是尽量尽快发来的监控链接付款了数据库',
                '零零零五分开了代课老师开发',
                '老师看了可是当时科夫利夫卡是到了',
                '所说的克拉科夫绿色开放',
                '的代码可以保证在进行多数据源驱动的时候',
                '设计语言与研发框架设计语言与研发框架',
                '这是 Ant Design 评价设计好坏的内在标准',
                '指引每个设计者做更好地判断和决策'
            ]

            let n = parseInt(Math.random() * tagArr.length - 1);
            return tagArr.slice(0, n);
        },
    }]
})

Mock.mock(/\/updatelist/, 'get', () => {
    let data = result.list;
    return {
        data
    }
})



